import { useParams, Navigate } from "react-router-dom";
import PremiumLandingPage from "./PremiumLandingPage";
import LocationLandingPage from "./LocationLandingPage";
import { PRODUCT_PAGES, SOLUTION_PAGES, LOCATION_PAGES } from "../../data/seoContent";

/**
 * Dynamic route handlers — map :slug -> content from data/seoContent.js.
 * Renders the single premium template per match. No per-page JSX files.
 */

export function ProductRoute({ onBook }) {
  const { slug } = useParams();
  // Dynamic Series has its own bespoke page; route handles it elsewhere.
  if (slug === "dynamic-series") return <Navigate to="/dynamic-series" replace />;
  const content = PRODUCT_PAGES[slug];
  if (!content) return <NotFound kind="product" />;
  return <PremiumLandingPage slug={slug} kind="products" content={content} onBook={onBook} />;
}

export function SolutionRoute({ onBook }) {
  const { slug } = useParams();
  const content = SOLUTION_PAGES[slug];
  if (!content) return <NotFound kind="solution" />;
  return <PremiumLandingPage slug={slug} kind="solutions" content={content} onBook={onBook} />;
}

export function LocationRoute({ onBook }) {
  const { slug } = useParams();
  const content = LOCATION_PAGES[slug];
  if (!content) return <NotFound kind="location" />;
  return <LocationLandingPage slug={slug} content={content} onBook={onBook} />;
}

function NotFound({ kind }) {
  return (
    <main data-testid={`not-found-${kind}`} className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6 pt-32 bg-[var(--gx-bg)] text-white">
      <p className="eyebrow mb-3">Page not found</p>
      <h1 className="font-display text-3xl tracking-tight max-w-[24ch]">
        This {kind} hasn&apos;t been published yet — but we&apos;d love to help.
      </h1>
      <a href="/contact" className="btn-outline mt-8">Talk to us</a>
    </main>
  );
}
